import _ from 'lodash';
import { getAppList } from '../lib/appsRegistry';
import baseRoutesMap from '../../routing/routesMap';

const buildRoutesMap = async ({ companyName, user, useTestPath } = {}) => {
  const appList = await getAppList({ companyName, useTestPath });
  const appsWithRoutes = _.filter(
    appList,
    app => typeof app.routesMap === 'function'
  );

  const routesMaps = await Promise.all(
    appsWithRoutes.map(app => app.routesMap({ user }))
  );

  return routesMaps.reduce(
    (acc, routeMap) => ({
      ...acc,
      ...routeMap,
    }),
    { ...baseRoutesMap }
  );
};

export default buildRoutesMap;
